import React from "react";
import ReactDOM from "react-dom";
import _ from "underscore";
import M from "../../../strings";
import { optional } from "../../../utils/lang";
import { isMobile } from "../../utils/mobile";
import { MaterialIcon } from "../materialIcon";
import withDropdown from "./dropdown";
import { isNotEmpty } from "../../../framework/utils";
import { checkCameraAvailability } from "../../../api/camera";
import Camera from "./camera";

class _PictureUploader extends React.Component {
    render() {
        return (
            <MaterialIcon
                {...this.props}
                icon="photo_camera"
            />
        )
    }
}

export function withPictureUpload(SourceComponent) {

    return class WrappedComponent extends React.Component {
        constructor(props) {
            super(props);
            this.inputRef = React.createRef();
            this.componentRef = React.createRef();
            this.state = {
                useDropdown: undefined,
                showCamera: false,
            }
        }

        onImagesAdded(fileImages) {
            if (this.props.onImagesAdded && _.isFunction(this.props.onImagesAdded)) {
                this.props.onImagesAdded(fileImages);
            }
        }

        onInputChange(e) {
            const fileImages = optional([...e.target.files],[]);
            e.target.files = null;
            e.target.value = null;

            this.onImagesAdded(fileImages);
        }

        onPicturesTaken(pictures) {
            this.hideCamera();
            this.onImagesAdded(pictures);
        }

        onClick() {
            const mobile = isNotEmpty(isMobile()),
                mediaDevicesSupported = 'mediaDevices' in navigator,
                useDropdown = this.state.useDropdown;

            if (mobile || !mediaDevicesSupported || useDropdown === false) { //useDropdown === false strong equality is important here
                this.triggerInput();
            } else if (useDropdown === undefined) {
                let cameraAvailable;
                checkCameraAvailability()
                    .then(() => {
                        cameraAvailable = true;
                    })
                    .catch(e => {
                        console.log(e);
                        cameraAvailable = false;
                    })
                    .finally(() => {
                        this.setState(
                            {useDropdown: cameraAvailable},
                            () => {
                                if (cameraAvailable) {
                                    ReactDOM.findDOMNode(this.componentRef.current)
                                        .querySelector("[data-toggle='dropdown']")
                                        .click();
                                } else {
                                    this.onClick();
                                }
                            }
                        )
                    })
            }
        }

        triggerInput() {
            this.inputRef.current.click();
        }

        showCamera() {
            this.setState({showCamera: true});
        }

        hideCamera() {
            this.setState({showCamera: false})
        }

        getComponent() {
            const useDropdown = this.state.useDropdown,
                dropdownOptions = this.props.dropdownOptions ?? {},
                items = [
                        (<div
                            onClick={this.showCamera.bind(this)}
                        >
                            {M("takePicture")}
                        </div>),
                        (<div
                            onClick={this.triggerInput.bind(this)}
                        >
                            {M("uploadPicture")}
                        </div>),
                    ];

            let className = "dropdown--dark";
            if (isNotEmpty(this.props.className)) {
                className += " " + this.props.className;
            }

            return useDropdown
                ? withDropdown(
                    SourceComponent,
                    items,
                    _.extend(
                        {},
                        dropdownOptions,
                        {
                            className:  className,
                        }
                    )
                )
                : SourceComponent;
        }

        render() {
            const Component = this.getComponent(),
                showCamera = this.state.showCamera;

            return (
                <>
                    <Component
                        ref={this.componentRef}
                        {...this.props}
                        onClick={this.onClick.bind(this)}
                    />
                    <div
                        className="d-none"
                    >
                        <input
                            ref={this.inputRef}
                            type="file"
                            multiple
                            accept="image/*"
                            onChange={this.onInputChange.bind(this)}
                        />
                    </div>
                    {showCamera && <Camera
                        onClose={this.hideCamera.bind(this)}
                        onError={this.hideCamera.bind(this)}
                        onSave={this.onPicturesTaken.bind(this)}
                    />}
                </>
            )
        }
    }
}

const PictureUploader = withPictureUpload(_PictureUploader);

export default PictureUploader;